import { Text } from './Text'

/**
 * Reusable callout banner that details a next step. Uses the design system's
 * "Next Step" status composition (yellow-50 fill, yellow-200 border) with a
 * primary-colored info icon and a line of descriptive text passed as children.
 *
 * The icon is inlined (not via <Icon>, whose assets carry fixed gray fills) so
 * it follows `currentColor` and renders in the brand primary — the same
 * approach the team uses for recolorable inline SVGs.
 */
export function NextStepBanner({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex items-center gap-2 rounded-[10px] border border-yellow-200 bg-yellow-50 px-3 py-3">
      {/* Info icon (ⓘ), brand-primary via currentColor. viewBox crops to the
          Figma 24×24 icon box so the glyph keeps its built-in padding. */}
      <svg
        viewBox="8 12 24 24"
        className="size-6 shrink-0 text-primary"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M26.334 24.334C26.334 21.0204 23.6475 18.3342 20.334 18.334C17.0203 18.334 14.334 21.0203 14.334 24.334C14.3342 27.6475 17.0204 30.334 20.334 30.334C23.6474 30.3338 26.3338 27.6474 26.334 24.334ZM19.667 27V24.334C19.667 23.9658 19.9658 23.667 20.334 23.667C20.702 23.6672 21 23.9659 21 24.334V27C21 27.3681 20.702 27.6668 20.334 27.667C19.9658 27.667 19.667 27.3682 19.667 27ZM20.3398 21C20.708 21 21.0068 21.2988 21.0068 21.667C21.0068 22.0352 20.708 22.334 20.3398 22.334H20.334C19.9658 22.334 19.667 22.0352 19.667 21.667C19.667 21.2988 19.9658 21 20.334 21H20.3398ZM27.667 24.334C27.6668 28.3838 24.3838 31.6668 20.334 31.667C16.284 31.667 13.0002 28.3839 13 24.334C13 20.2839 16.2839 17 20.334 17C24.3839 17.0002 27.667 20.284 27.667 24.334Z" />
      </svg>
      <Text variant="sm" weight="medium" className="text-gray-900">
        {children}
      </Text>
    </div>
  )
}
